module.exports = __webpack_public_path__ + "static/img/partner-logo17.7a14068e.png";